var map = {
	"./blogger.js": 24,
	"./collections.js": 25,
	"./delicious.js": 26,
	"./digg.js": 27,
	"./evernote.js": 28,
	"./facebook.js": 29,
	"./linkedin.js": 30,
	"./lj.js": 31,
	"./messenger.js": 32,
	"./moimir.js": 33,
	"./odnoklassniki.js": 34,
	"./pinterest.js": 35,
	"./pocket.js": 36,
	"./qzone.js": 37,
	"./reddit.js": 38,
	"./renren.js": 39,
	"./sinaWeibo.js": 40,
	"./skype.js": 41,
	"./surfingbird.js": 42,
	"./telegram.js": 43,
	"./tencentWeibo.js": 44,
	"./tumblr.js": 45,
	"./twitter.js": 46,
	"./viber.js": 47,
	"./vkontakte.js": 48,
	"./whatsapp.js": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;